import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import * as tutorialActions from '../tutorial.actions'
const TutorialBuildMessageScreen = ({ removeScreen }) => (
  <div className="tutorial--response" style={{ zIndex: '1000' }}>
    <h1 className="h1">
      <FormattedMessage id="tutorial.turn1.title" />
    </h1>
    <p>
      <FormattedMessage id="tutorial.turn1.body.p1" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn1.body.p1bis" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn1.body.p2" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn1.body.p3" />
      <b>
        <FormattedMessage id="tutorial.turn1.body.p3_End" />
      </b>
    </p>
    <p>
      <FormattedMessage id="tutorial.turn1.body.p4" />
      <b>
        <FormattedMessage id="tutorial.turn1.body.p4_End" />
      </b>
    </p>
    <div className="btn--orange" onClick={() => removeScreen('build_message_screen')}>
      <span className="icon-rocket"></span>
      <span>
        <FormattedMessage id="tutorial.common_texts.start" />
      </span>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
})

TutorialBuildMessageScreen.propTypes = {
  removeScreen: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TutorialBuildMessageScreen))
